export const campaignConfig = {
  id: 'vejle-historisk-adventure-demo',
  title: 'Vejles Koder – Historisk Adventure',
  edition: 'DEMO',
  websiteUrl: 'https://vejleskoder.dk',
} as const;
